import React, { useContext } from 'react';
import { css } from '@emotion/react';
import { AngularServicesContext } from 'react-app';
import { useSelector } from 'react-redux';

import { getCurrentCourse } from 'redux/selectors/course';

import EditModeCenterButton from 'lecture_pages/components/edit-menu/actions/edit-mode-center-button';
import ExitButton from 'lecture_pages/components/edit-menu/actions/exit-button';
import { institutionBrandBorderWidth, lectureTopPanelZIndex } from 'styles/global_defaults/scaffolding';
import BulkAddToCollectionButton from './bulk-add-to-collection-button';
import EditModeLeftPanel from './edit-mode-left-panel';

const styles = css`
  position: absolute;
  width: 100%;
  height: 60px;
  top: -${institutionBrandBorderWidth}px;
  left: 0px;
  z-index: ${lectureTopPanelZIndex};

  .close-edit-mode-button {
    position: absolute;
    right: 0;
  }
`;

const EditModeTopPanel = () => {
  const { $state } = useContext(AngularServicesContext);
  const { catalogId, isProgram } = useSelector(getCurrentCourse);

  const exitToPreviousMode = () => {
    $state.go(isProgram ? 'program-home' : 'course-home', { catalogId });
  };

  return (
    <div css={styles} className='d-flex align-items-center justify-content-center bg-black'>
      <EditModeLeftPanel />
      <div className='edit-mode-buttons align-items-center'>
        <EditModeCenterButton exitToPreviousMode={exitToPreviousMode} />
      </div>
      <div className='close-edit-mode-button align-items-center d-flex'>
        <BulkAddToCollectionButton />
        <ExitButton onClick={() => exitToPreviousMode()} />
      </div>
    </div>
  );
};

export default EditModeTopPanel;
